import {AfterContentInit, AfterViewInit, Component} from '@angular/core';
import {
  ControlService,
  IconService,
  InputBoxService,
  SubtitlesService
} from "../../../core";
import {MenuElementType112, MenuType} from "../../../models";

@Component({
  selector: 'checkbox-expanded',
  templateUrl: './checkbox-expanded.component.html',
  styleUrls: ['./checkbox-expanded.component.scss']
})
export class CheckboxExpandedComponent implements AfterViewInit, AfterContentInit {
  constructor(
      public control: ControlService,
      private icon: IconService,
      public inputBox: InputBoxService,
      private subtitles: SubtitlesService,
  ) {
  }

  ngAfterViewInit() {
    this.control.setOverflow();
  }

  ngAfterContentInit() {
    this.inputBox.getCheckBox();
  }

  setIcon(val: number | MenuType): string {
    if (val === null) return;

    return this.icon.setIcon(val);
  }

  subtitle(val: number): string {
    return val !== 0 ? this.subtitles.setSubtitle(val) : '';
  }

  getMenuElement(): MenuElementType112 {
    return this.control.elementVal.getValue() as MenuElementType112;
  }
}
